<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-tabView class="custom-tabs-seguros" (onChange)="onTabChange($event)" [activeIndex]="indiceActivo">
        <p-tabPanel header="{{ 'SEGURO.LBL_SEGUROS' | translate }}" [selected]="tabSeleccionado === 'SEGU'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
            <div class="grid">
              <div class="col-12 md:col-2">
                <div class="div-form">
                  <label>* {{ 'SEGURO.LBL_CODSEGU' | translate }}</label>
                  <div>
                    <input type="text" pInputText id="codigo"
                           name="nomCodigo"
                           autocomplete="off"
                           formControlName="codigo" codigos-reactive
                           (blur)="validarCodigo()"
                           [maxlength]="20"

                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                      {{ 'SEGURO.LBL_CODSEGU' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="div-form">
                  <label>* {{ 'SEGURO.LBL_NOMSEGU' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         capitalize-reactive
                         sin-numeros-reactive
                         [maxlength]="100"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'SEGURO.LBL_NOMSEGU' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-3">
                <div class="div-form">
                  <label>* {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate }}</label>
                  <p-multiSelect id="idTipoPersona" name="nomTipoPersona" [options]="listasTiposPersonas"
                                 filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="naturaleza"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.naturaleza.invalid">
                    {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-3">
                <div class="div-form">
                  <label>* {{ 'SEGURO.LBL_PLANTILLA' | translate }}</label>
                  <p-dropdown disableTab  id="idPlantillaDigital" name="nomIdPlantillaDigital" [options]="lisPlantilla"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              formControlName="idPlantillaDigital"
                              filter="filter"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.idPlantillaDigital  .invalid">
                    {{ 'SEGURO.LBL_PLANTILLA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SEGURO.LBL_POLIZAMAESTRA' | translate }}</label>
                  <input type="text" pInputText id="idPolMae"
                         name="nomPolizaMaestra"
                         autocomplete="off"
                         formControlName="polizaMaestra" codigos-reactive
                         [maxlength]="10"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.polizaMaestra.invalid">
                    {{ 'SEGURO.LBL_POLIZAMAESTRA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="seccion-container-seguro">
              <div class="seccion-titulo banca">
                {{ 'SEGURO.LBL_BANCARELACIONAL' | translate | uppercase }}
              </div>
            <div class="grid col-12 px-0">
              <div class="col-12 md:col-6 lg:col-6 px-0">
                <div class="div-form">
                  <div class="row col-12">
                    <label>{{ 'SEGURO.LBL_DESCRIPCION' | translate }}</label>
                  </div>
                  <div class="row col-12">
                    <quill-editor [style]="{'width':' 100%'}" [modules]="modQuill" trackChanges="all"
                                  [placeholder]="'LBL_INGRESETEXTO' | translate" #cuerpo
                                  formControlName="descripcion">
                      <div quill-editor-toolbar>
                      <span class="ql-formats">
                        <select class="ql-font">
                          <option selected></option>
                          <option value="serif"></option>
                          <option value="monospace"></option>
                          <option value="comic">Comic Sans</option>
                          <option value="firesans">Fire Sans</option>
                        </select>
                        <select class="ql-size">
                          <option value="small"></option>
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                        <button class="ql-strike"></button>
                      </span>
                        <span class="ql-formats">
                        <select class="ql-color"></select>
                        <select class="ql-background"></select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select class="ql-align">
                          <option selected></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-link"></button>
                        <button class="ql-image"></button>
                      </span>
                      </div>
                    </quill-editor>
                  </div>

                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6 px-0">
                <div class="div-form">
                  <div class="row col-12">
                    <label>{{ 'SEGUROCOBERTURAS.LBL_DESCRIPCION' | translate }}</label>
                  </div>
                  <div class="row col-12">
                    <quill-editor [style]="{'width':' 100%'}" [modules]="modQuill" trackChanges="all"
                                  [placeholder]="'LBL_INGRESETEXTO' | translate"
                                  formControlName="descripcionCobertura">
                      <div quill-editor-toolbar>
                      <span class="ql-formats">
                        <select class="ql-font">
                          <option selected></option>
                          <option value="serif"></option>
                          <option value="monospace"></option>
                          <option value="comic">Comic Sans</option>
                          <option value="firesans">Fire Sans</option>
                        </select>
                        <select class="ql-size">
                          <option value="small"></option>
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                        <button class="ql-strike"></button>
                      </span>
                        <span class="ql-formats">
                        <select class="ql-color"></select>
                        <select class="ql-background"></select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select class="ql-align">
                          <option selected></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-link"></button>
                        <button class="ql-image"></button>
                      </span>
                      </div>
                    </quill-editor>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div class="seccion-container-seguro">
              <div class="seccion-titulo banca">
                {{ 'SEGURO.LBL_BILLETERA' | translate | uppercase }}
              </div>
            <div class="grid px-0">
              <div class="col-6 px-0">
                <div class="div-form">
                  <div class="row col-12">
                    <label>{{ 'SEGURO.LBL_DESCRIPCIONBILLETERA' | translate }}</label>
                  </div>
                  <div class="row col-12">
                    <quill-editor [style]="{'width':' 100%'}" [modules]="modQuill" trackChanges="all"
                                  [placeholder]="'LBL_INGRESETEXTO' | translate" #cuerpo
                                  formControlName="descripcionBilletera">
                      <div quill-editor-toolbar>
                      <span class="ql-formats">
                        <select class="ql-font">
                          <option selected></option>
                          <option value="serif"></option>
                          <option value="monospace"></option>
                          <option value="comic">Comic Sans</option>
                          <option value="firesans">Fire Sans</option>
                        </select>
                        <select class="ql-size">
                          <option value="small"></option>
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                        <button class="ql-strike"></button>
                      </span>
                        <span class="ql-formats">
                        <select class="ql-color"></select>
                        <select class="ql-background"></select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select class="ql-align">
                          <option selected></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-link"></button>
                        <button class="ql-image"></button>
                      </span>
                      </div>
                    </quill-editor>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0">
                <div class="div-form">
                  <div class="row col-12">
                    <label>{{ 'SEGUROCOBERTURAS.LBL_DESCRIPCIONBILLETERA' | translate }}</label>
                  </div>
                  <div class="row col-12">
                    <quill-editor [style]="{'width':' 100%'}" [modules]="modQuill" trackChanges="all"
                                  [placeholder]="'LBL_INGRESETEXTO' | translate"
                                  formControlName="descripcionCoberturaBilletera">
                      <div quill-editor-toolbar>
                      <span class="ql-formats">
                        <select class="ql-font">
                          <option selected></option>
                          <option value="serif"></option>
                          <option value="monospace"></option>
                          <option value="comic">Comic Sans</option>
                          <option value="firesans">Fire Sans</option>
                        </select>
                        <select class="ql-size">
                          <option value="small"></option>
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                        <button class="ql-strike"></button>
                      </span>
                        <span class="ql-formats">
                        <select class="ql-color"></select>
                        <select class="ql-background"></select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select class="ql-align">
                          <option selected></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-link"></button>
                        <button class="ql-image"></button>
                      </span>
                      </div>
                    </quill-editor>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div class="grid align-items-center" style="margin-top: 16px; gap: 16px; flex-wrap: wrap;">

              <div  class="inputSwitch-container">
                <p-inputSwitch  formControlName="indicadorHabilitado"></p-inputSwitch>
                <label style="margin:0;">{{'LBL_HABILITADO' | translate}}</label>
              </div>


              <div class="calculo-prima-group">
                <span class="calculo-prima-label">{{ 'SEGURO.LBL_CALCULOPRIMA' | translate | uppercase }}</span>
                <div class="radio-pill">
                  <p-radioButton name="indicadorTasa" [value]="false" id="plan"
                                 label="{{ 'SEGURO.LBL_PLAN' | translate }}"
                                 formControlName="indicadorTasa"
                                 (onClick)="verificarValidadores()"></p-radioButton>
                  <p-radioButton name="indicadorTasa" [value]="true" id="tasa"
                                 label="{{ 'SEGURO.LBL_TASA' | translate }}"
                                 formControlName="indicadorTasa"
                                 (onClick)="verificarValidadores()"></p-radioButton>
                </div>
              </div>
            </div>
            <div class="checkboxes-container">
            <div class="grid align-items-center" style="margin-top: 12px;">

              <div class="col-12 md:col-6" [ngClass]="{'beneficiarios-bordered-box': f.indicadorBeneficiarios.value}">
                <div class="grid align-items-center h-full">
                  <div class="col-12" [ngClass]="f.indicadorBeneficiarios.value ? 'md:col-6' : 'md:col-12'">
                    <p-checkbox label="{{ 'SEGURO.LBL_BENEFI' | translate }}" binary="true"
                                id="indicadorBeneficiarios" name="nomIndicadorBeneficiarios"
                                formControlName="indicadorBeneficiarios">
                    </p-checkbox>
                  </div>

                  <div *ngIf="f.indicadorBeneficiarios.value" class="col-12 md:col-6 inputSwitch-container flex align-items-center">
                    <p-inputSwitch formControlName="indicadorBeneficiariosLey" #switchLey></p-inputSwitch>
                    <label style="margin:0;">{{'SEGURO.LBL_BENEFICIARIOLEY' | translate}}</label>
                  </div>

                </div>
              </div>

              <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
                <p-checkbox label="{{ 'SEGURO.LBL_DECLRIES' | translate }}" binary="true"
                            id="indicadorDeclaracionRiesgo" name="nomIndicadorDeclaracionRiesgo"
                            formControlName="indicadorDeclaracionRiesgo"
                            (click)="verificarValidadores()"></p-checkbox>
              </div>

              <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
                <p-checkbox label="{{ 'SEGURO.LBL_REQUIREIMC' | translate }}" binary="true"
                            id="indicadorRequiereImc" name="nomIndicadorRequiereImc"
                            formControlName="indicadorRequiereImc"></p-checkbox>
              </div>

              <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
                <p-checkbox label="{{ 'SEGURO.LBL_ASEGURANEGOCIO' | translate }}" binary="true"
                            id="indicadorAseguraNegocio" name="nomIndicadorAseguraNegocio"
                            formControlName="indicadorAseguraNegocio"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
                <p-checkbox label="{{ 'SEGURO.LBL_ASEGURACONTENIDONEGOCIO' | translate }}" binary="true"
                            id="indicadorAseguraContenidoNegocio" name="nomIndicadorAseguraContenidoNegocio"
                            formControlName="indicadorAseguraContenidoNegocio"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
                <p-checkbox label="{{ 'SEGURO.LBL_ASEGURACASA' | translate }}" binary="true"
                            id="indicadorAseguraHogar" name="nomIndicadorAseguraHogar"
                            formControlName="indicadorAseguraHogar"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
                <p-checkbox label="{{ 'SEGURO.LBL_ASEGURACONTENIDOHOGAR' | translate }}" binary="true"
                            id="indicadorAseguraContenidoHogar" name="nomIndicadorAseguraContenidoHogar"
                            formControlName="indicadorAseguraContenidoHogar"></p-checkbox>
              </div>
            </div>
            </div>

            <div class="grid" *ngIf="f.indicadorTasa.value">
              <div class="col-12 md:col-4 lg:col-4" >
                <div class="div-form" >
                  <label>* {{ 'SEGURO.LBL_VALORTASA' | translate }}</label>
                  <input type="text" pInputText id="valorTasa"
                         name="nomValorTasa"
                         autocomplete="off"
                         formControlName="valorTasa" numero-decimal-reactive
                         [decimales]="6"
                         [maximo]="100"
                         [maxlength]="10"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valorTasa.invalid">
                    {{ 'SEGURO.LBL_VALORTASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ 'SEGURO.LBL_VALORASEGURADO' | translate }}</label>
                  <p-dropdown disableTab  id="idValorAsegurado" name="nomIdValorAsegurado" [options]="lisTiposValoresAsegurados"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idValorAsegurado"
                              filter="filter"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idValorAsegurado.invalid">
                    {{ 'SEGURO.LBL_VALORASEGURADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid" *ngIf="f.indicadorDeclaracionRiesgo.value">
              <div class="col-12 md:col-4 lg:col-4" >
                <div class="div-form">
                  <label>* {{ 'SEGURO.LBL_CUESTIONARIO' | translate }}</label>
                  <p-dropdown disableTab  id="idCuestionario" name="nomIdCuestionario" [options]="lisCuestionarios"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              formControlName="idCuestionario"
                              filter="filter"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCuestionario.invalid">
                    {{ 'SEGURO.LBL_CUESTIONARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <div *ngIf="f.idAdjuntoIcono.value && !subAdjunto" class="btn-group" role="group"
                       style="display: block;">
                    <label class="btn btn-default" style="max-width: 87%; overflow: hidden;">
                      <img [src]="imagen" width="50" height="50" alt="imagen"/>
                      {{f.nombreArchivo.value}}
                    </label>
                    <a class="btn btn-danger" (click)="eliminarAdjunto()" style="padding: 3px; border-radius: 5px;">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                  </div>
                  <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                                chooseLabel="{{'SEGURO.LBL_ADJUNTAR' | translate}}" #adjunto
                                (onBeforeUpload)="onBeforeSend($event)"
                                (onValidSelect)="onSelect($event, $event.files)"
                                (onUpload)="uploadingOk($event)"
                                invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                                invalidFileTypeMessageDetail="{{'SEGURO.LBL_FILETIPOES' | translate}}"
                                mode="basic" fSize [accept]="ftype">
                  </p-fileUpload>
                  <div *ngIf="((f.idAdjuntoIcono.value == null))">
                    {{ 'LBL_TAMANOMAXIMO' | translate}}: {{fsize / 1000000}} MB <br>
                    {{ 'LBL_TIPOARCHIVO' | translate}}: {{'SEGURO.FTYPE' | translate }}
                  </div>
                </div>
              </div>

            </div>


            <div class="grid" *ngIf="seguro && seguro.idSeguro">
              <div class="grid12 md:col-3 lg:col-3">
                <button icon="fa fa-file" label="{{'SEGURO.LBL_CONDICIONADO' | translate }}" (click)="verAdjunto()"
                        type="button" *ngIf="!carAdjunto"
                        pButton></button>
                <div *ngIf="carAdjunto">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_CONSULTANDO' | translate }}</span>
                </div>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-tabPanel>
        <p-tabPanel header="{{ 'SEGURO.LBL_PLANES' | translate }}"
                        [disabled]="!seguro"
                        *ngIf="seguro && !seguro.indicadorTasa">
          <app-seguro-plan [seguro]="seguro" *ngIf="seguro && seguro.idSeguro"
                           (dismiss)="cambiarTabSeleccionado($event)"></app-seguro-plan>
        </p-tabPanel>

        <p-tabPanel header="{{ 'SEGURO.LBL_COBERTURAS' | translate }}"
                        [disabled]="!seguro"
                        *ngIf="seguro">

          <app-seguros-coberturas [seguro]="seguro" *ngIf="seguro && seguro.idSeguro"></app-seguros-coberturas>

        </p-tabPanel>

        <p-tabPanel header="{{ 'SEGURO.LBL_BIENES' | translate }}"
                    [disabled]="!seguro"
                    *ngIf="seguro && (seguro.indicadorAseguraHogar || seguro.indicadorAseguraNegocio || seguro.indicadorAseguraContenidoHogar || seguro.indicadorAseguraContenidoNegocio)">

          <app-seguros-bienes
            (cancelar)="cambiarTabSeleccionado('SEGU')"
            [seguro]="seguro"
            *ngIf="seguro && seguro.idSeguro">
          </app-seguros-bienes>

        </p-tabPanel>


      </p-tabView>
      <div class="grid form-footer-buttons" *ngIf="seguro && seguro.idSeguro && tabSeleccionado !== 'BIENES'">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-dialog
  [(visible)]="mostrarDlgAdjunto"
  header="{{'SEGURO.LBL_CONDICIONADO' | translate }}"
  [modal]="true" *ngIf="mostrarDlgAdjunto"
  [draggable]="false" width="800"
  positionTop="10">
  <div class="grid" *ngIf="rutAdjunto">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <div id="dRecurso" style="width: 100%;float: left;">
        <iframe id="ifrAdjuntoAlerta" width="100%" height="400" [src]="rutAdjunto"
                onload="iResize();" title=""></iframe>
      </div>
    </div>
  </div>
  <div class="iu-g" *ngIf="!rutAdjunto">
    <div class="col-12md:col-12 lg:col-12 text-center">
      <h3> {{'SEGURO.MSG_ADJUNTO' | translate}}</h3>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrar()"></button>
    </div>
  </div>
</p-dialog>
